<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 mydiv" id="oh-lilliana">
<h1>Oh Lilliana</h1>
<p>Oh Lilliana, there’s something about you</p>
<p>Lilliana, Lilliana, Lilliana</p><br/>
<p>When I see you, you make me so happy</p>
<p>All the anger and frustration just melts away</p>
<p>I could lay next to you all day, Lilliana</p>
<p>Not go to work today, just rest and play</p><br/>
<p>Lilliana, Lilliana, Lilliana</p>
<p>You make me smile every day, Lilliana</p><br/>
<p>Oh Lilliana, there’s something about you</p>
<p>Lilliana, Lilliana, Lilliana</p><br/>
<p>Oh don’t ever leave me, Lilliana</p>
<p>You make my life so gay,</p>
<p>When I see you waiting for me</p>
<p>Just can’t wait to see you, waiting, patiently, waiting</p>
<p>Oh I love yah</p><br/>
<p>Lilliana, Lilliana, Lilliana</p>
<p>There’s something about you,</p>
<p>Lilliana, Lilliana, Lilliana</p><br/>
<p>You’re my world, you beautiful thing</p>
<p>You’re the rays through the window</p>
<p>And even when it rains, you’re waiting</p>
<p>We snuggle up close and the day is light,</p>
<p>Lilliana</p>
<p>Oh there’s something about you, Lilliana</p><br/>
<p>It’s the way you tilt your head and look at me</p>
<p>It’s the way you wait so patiently</p>
<p>Oh Lilliana, I love you so much, I do</p>
<p>Don’t leave me will you, oh Lilliana</p><br/>
<p>Lilliana, Lilliana, Lilliana</p><br/>
<p>It’s the times today we worry about</p>
<p>But with you by my side, it will all work out</p>
<p>Please don’t leave me, don’t leave me, Lilliana</p>
<p>Lilliana, Lilliana,</p><br/>
<p>I will see you waiting and I will be right there</p>
<p>Lilliana, Lilliana, Lilliana</p>
<p>And I kiss you when you sleep and wait for you to wake,</p>
<p>Oh Lilliana</p><br/>
<p>We will wake up in the light and I chase you over the green,</p>
<p>Lilliana</p>
<p>And then we will lay by each other’s side,</p>
<p>And we will kiss one another goodnight, Lilliana</p><br/>
<p>I will see you in the morning when the sun shines</p>
<p>Lilliana.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?513cc784